import React, { useState } from "react";
import {Checkbox} from "@project-stories/elements/Checkbox/Checkbox";
import "./BackInStock.scss";

export const BackInStock = ({ settings  }) => {
    const [email, setEmail] = useState("");
    const [step, setStep] = useState("button"); // 'button', 'form', 'message'
    const [message, setMessage] = useState({ text: "", isError: false });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [notifyOther, setNotifyOther] = useState(false);

    const productId = settings.productId;
    const listId = settings.settings.klaviyo_list_id;
    const klaviyoAPIKey = settings.settings.klaviyo_api_key;
    const variantId = window.currentVariant;

    const handleSubscribe = async () => {
        const endpoint = `https://a.klaviyo.com/client/subscriptions/?company_id=${klaviyoAPIKey}`
        const subscribeData = {
            data: {
                "type": "subscription",
                "attributes": {
                    "profile": {
                        "data": {
                            "type": "profile",
                            "attributes": {
                                "email": `${email}`
                            }
                        }
                    },

                },
                "relationships": {
                    "list": {
                        "data": {
                            "type": "list",
                            "id": `${listId}`
                        }
                    }
                }
            }
        };
    
        try {
            await fetch(endpoint, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "revision": "2025-01-15"
                },
                body: JSON.stringify(subscribeData),
            });
        } catch (error) {
          throw new Error(error, 'Error in subscribing to email marketing')
        }
      }

    const handleSubmit = async () => {
        if (!email) {
            setMessage({ text: "Please enter a valid email.", isError: true });
            return;
        }

        setIsSubmitting(true);

        try {
            const BISSubscribeData = {
                data: {
                    "type": "back-in-stock-subscription",
                    "attributes": {
                        "profile": {
                            "data": {
                                "type": "profile",
                                "attributes": {
                                    "email": `${email}`
                                }
                            }
                        },
                        "channels": ['EMAIL']
                    },
                    "relationships": {
                        "variant": {
                            "data": {
                                "type": "catalog-variant",
                                "id": `$shopify:::$default:::${variantId}`
                            }
                        }
                    }
                }
            };

            const response = await fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=${klaviyoAPIKey}`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "revision": "2025-01-15"
                },
                body: JSON.stringify(BISSubscribeData),
            });

            if (notifyOther) {
                await handleSubscribe();
            }

            if (response.ok) {
                setMessage({
                    text: "Thank you for registering. We will notify you when this size becomes available.",
                    isError: false,
                });
                setStep("message");
            } else {
                const errorData = await response.json();
                throw new Error(errorData.message || "Something went wrong.");
            }
        } catch (error) {
            setMessage({ text: error.message, isError: true });
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="back-in-stock-container">

            <button
                onClick={() => setStep("form")}
                className="button button-primary w-full"
            >
                Notify Me
            </button>

            {step === "form" && (
                <div className="email-form flex flex-col gap-[16px]">

                    <div className="text-field-wrap flex items-center mt-[32px] gap-x-[8px]">
                        <label htmlFor="email" className="h5">
                            EMAIL
                        </label>
                        <input
                            type="email"
                            id="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder=""
                            className={`form-field h6 border-b w-full focus:outline-none`}
                        />
                        <button
                            onClick={handleSubmit}
                            disabled={isSubmitting}
                            className="ml-2 text-black"
                        >
                            →
                        </button>
                    </div>
                    {message.text && (
                        <p
                            className={`mt-2 text-sm ${
                                message.isError ? "text-red-500" : "text-green-500"
                            }`}
                        >
                            {message.text}
                        </p>
                    )}

                    <div className={'flex'}>
                        <Checkbox
                            classes={'b2'}
                            name={'notify_other'}
                            label={`Notify me about new arrivals and offers`}
                            id={'notify_other'}
                            checked={notifyOther} // Bind state to checkbox
                            onChange={(e) => setNotifyOther(e.target.checked)} // Handle change
                        />
                    </div>
                </div>
            )}

            {step === "message" && (
                <div className="message pt-[32px]">
                    <p className="b2">{message.text}</p>
                </div>
            )}
        </div>
    );
};

export default BackInStock;
